import { ComponentView } from "binder";
import { PictureCaptureViewModel } from "./pictureCapture-viewModel"

export class PictureCaptureView extends ComponentView<PictureCaptureViewModel>{
    GetViewUniqueId(): string {
        return "V-AE6F7FA5-5462-4121-8056-DD4CBF58AA79"
    }
    loadHtml(): string {
        let element = require('./pictureCapture.html').default;
        let style = require('./pictureCapture.less');
        return element;
    }
    constructor() {
       super();
    }
    private _fileSelector:HTMLInputElement;
    onRenderCompleted(){
        this._fileSelector = this.firstlevelElement.querySelector('#inp');
    }
    takeImage(){
        this._fileSelector.click();
    }
    fileChanged(e){
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.onload = ev=>{
            let content =(<any> ev.target.result);
            this.image = content;
        }
        reader.readAsDataURL(file);
    }
    public set image(v: string) { this._image = v; } public get image(): string { return this._image;} private _image: string;
    
    chooseFile(){
        let input = document.createElement('input');
        input.type = 'file';
        input.onchange = e => { 
            let file = (<any>e).target.files[0]; 
            let reader = new FileReader();
            reader.readAsDataURL(file); 
            reader.onload = readerEvent => {
                let content =(<any> readerEvent.target.result);
                this.image = content;
            }
        }
        input.click(); 
    }
}
